<template>
    <b-button-group class="rental-expenses__account">
        <form-select
            id="rental-expenses-account-id"
            class="rental-expenses__account-id"
            :value="value"
            :options="accountExpenseOptions"
            :error="error"
            @input="handleValueChange"
        ></form-select>
        <responsive-button
            :with-space="false"
            :icon="['fas', 'plus']"
            class="rental-expenses__account-add"
            variant="primary"
            @click="showExpenseAccountModal"
        ></responsive-button>
        <expense-account-modal
            :showModal="isExpenseAccountModalShown"
            :expenseAccount="expenseAccount"
            @save="saveExpenseAccount"
            @modalHide="hideExpenseAccountModal"
        ></expense-account-modal>
    </b-button-group>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { getNextAccountExpenseNumber } from '../../../utils/account-expense';
    import FormSelect from '../../generic/form-select/form-select.vue';
    import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
    import ExpenseAccountModal from '../../work-orders/work-orders-configuration-options/expense-account-modal.vue';

    export default {
        name: 'RentalExpenseAccountSelect',
        components: {
            ExpenseAccountModal,
            FormSelect,
            ResponsiveButton,
        },
        props: {
            value: {
                type: Number,
                default: null,
            },
            error: {
                type: String,
                default: null,
            }
        },
        computed: {
            ...mapGetters('workOrders', [
                'accountExpenses',
            ]),
            accountExpenseOptions() {
                return this.accountExpenses.map(expense => ({
                    value: expense.id,
                    text: `${expense.number} - ${expense.name}`,
                }))
            },
        },
        data() {
            return {
                expenseAccount: {},
                isExpenseAccountModalShown: false,
            }
        },
        methods: {
            async saveExpenseAccount(expenseAccount) {
                try {
                    const createdAccountExpense = await this.$store.dispatch(
                        'workOrders/createAccountExpense', expenseAccount
                    );
                    this.handleValueChange(createdAccountExpense.id);
                } catch (err) {
                    this.errorToast({text: 'Could not create account expense.'})
                }
            },
            handleValueChange(value) {
                this.$emit('input', value);
            },
            showExpenseAccountModal() {
                this.isExpenseAccountModalShown = true;
            },
            hideExpenseAccountModal() {
                this.isExpenseAccountModalShown = false;
            },
        },
        watch: {
            isExpenseAccountModalShown() {
                if (this.isExpenseAccountModalShown) {
                    this.expenseAccount = {
                        number: getNextAccountExpenseNumber(this.accountExpenses)
                    };
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .rental-expenses {
        &__account {
            width: 100%;

            &-id {
                width: 93%;
            }

            &-add {
                height: 2.4rem;
                margin-right: 0px !important;
            }
        }
    }
</style>